import type { BaseTranslation } from '../i18n-types';

export const menu = {
    home: 'Home',
    stories: 'Stories',
    messages: 'Messages',
    favorites: 'Favorites',
    chatHistory: 'Chat History',
} satisfies BaseTranslation;
